<template>
  <div>
    <base-header type="gradient-info" class="pb-1 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col">
          <h1 class="text-white pt-3 px-3">หน้าจัดการใบนำส่งพัสดุ</h1>
          <p class="text-white pb-3 px-3">
            แสดงข้อมูลพัสดุทั้งหมดของสาขาที่ยังไม่ได้สร้างใบนำส่งพัสดุ โดยสามารถเลือกวันที่สามารถมาแสดงผลได้</p>
        </div>
        <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
          <template v-if="selected.length > 0">
            <button 
              class="btn btn-xl btn-warning" 
              :disabled="selected.length < 1" 
              @click="showComfirmModal()"
            >
              สร้างใบนำส่งพัสดุ
            </button>
          </template>
          <template v-else-if="createTypeBy === TYPE.SCAN">
            <button 
              class="btn btn-xl btn-warning"
              @click="onChangeCreateType()"
            >
              เสร็จสิ้น
            </button>
          </template>
          <template v-else>
            <button 
              class="btn btn-xl btn-warning"
              @click="onChangeCreateType(TYPE.SCAN)"
            >
              สแกนสร้างใบนำส่งพัสดุ
            </button>
          </template>
        </div>
        <template v-if="createTypeBy === TYPE.SCAN">
          <div class="col-12 mb-1">
            <ScanSOP @onUpdate="onScanSuccess" />
          </div>
        </template>
        <div class="col-12">
          <BacklogParcel />
        </div>
      </div>
    </base-header>
    
    <div class="container-fluid mt-1 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                  <b-form-group label="ค้นหาวันที่ (วันเริ่มต้น - วันสุดท้าย)" class="mb-0">
                    <div class="row">
                      <div class="col-8 col-md-8 col-lg-6">
                        <date-range-picker
                            class="w-100"
                            :opens="'center'"
                            :singleDatePicker="false"
                            :appendToBody="true"
                            :ranges="false"
                            :closeOnEsc="false"
                            :autoApply="true"
                            :locale-data="{ format: 'dd/mm/yyyy' }"
                            v-model="filters">
                        </date-range-picker>
                      </div>
                      <div class="col-4 col-md-3 col-lg-2">
                        <button class="btn btn-info btn-sm-res" v-on:click="getDelivery()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                     
                    </div>
                  </b-form-group>
                  <hr class="d-md-none d-lg-none" />
                </div>
                <div class="col-12 col-md-12 col-lg-8 col-xl-6 mb-3"> 
                  <div class="row">
                    <b-form-group
                      id="input-group-1"
                      label="ค้นหาข้อมูล"
                      label-for="input-1"
                      class="mb-0 col-6"
                    >
                    <b-form-input v-model="filter" id="input-1" type="text" required placeholder></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="input-group-1"
                      label="ค้นหาขนส่ง"
                      label-for="input-1"
                      class="mb-0 col-6"
                    >
                      <select class="form-control" @click.stop.prevent v-model="selectFilter">
		                    <option :value="undefined">ทั้งหมด</option>
		                	  <option :value="option" v-for="option in options" :key="option">{{ option }}</option>
                      </select>
                    </b-form-group>
                  </div>
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
              </div>
            </div>
            <div id="tablePrint">
              <b-table
                ref="reportDelivery"
                show-empty
                responsive
                :selectable="createTypeBy === TYPE.DEFAULT"
                :items="itemFilter"
                :fields="fields"
                :busy="busy"
                @row-selected="onRowSelected"
                class="scroll-bar-pop"
                foot-clone
              >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="HEAD_selected" v-if="createTypeBy === TYPE.DEFAULT">
                  <b-form-checkbox v-model="checkSelect" @change="selectAllRows" class="text-center"></b-form-checkbox>
                </template>
                <template 
                  slot="selected" 
                  slot-scope="{ rowSelected }"
                  v-if="createTypeBy === TYPE.DEFAULT"
                >
                    <template v-if="rowSelected">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                        <label class="custom-control-label"></label>
                      </div>
                    </template>
                    <template v-else>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                        <label class="custom-control-label"></label>
                      </div>
                    </template>
                </template>
                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                <template slot="created_at" slot-scope="row">{{ row.item.created_at.date | dateFormat }}</template>
                <template slot="dimension" slot-scope="row"> 
                  {{ ( Number(row.item.dimension.width)+Number(row.item.dimension.length)+Number(row.item.dimension.height) ) > 3 ? row.item.dimension.width+'x'+row.item.dimension.length+'x'+row.item.dimension.height : '-'}}
                </template>
                <template slot="weight" slot-scope="row">
                  {{ (row.item.weight) ? ( ( $THEME.unitKG ) ? (row.item.weight / 1000) : row.item.weight ) : '-'}}
                </template>
            
                <template slot="FOOT_selected">&nbsp;</template>
                <template slot="FOOT_index">&nbsp;</template>
                <template slot="FOOT_created_at"> &nbsp;</template>
                <template slot="FOOT_postcode"> &nbsp;</template>
                <template slot="FOOT_name"> &nbsp;</template>
                <template slot="FOOT_province"> &nbsp;</template>
                <template slot="FOOT_receipt_no"> &nbsp;</template>
                <template slot="FOOT_tel"> &nbsp;</template>
                <template slot="FOOT_barcode"> &nbsp; </template>
                <template slot="FOOT_courier">&nbsp; </template>
                <template slot="FOOT_weight"> &nbsp;</template>
                <template slot="FOOT_dimension"> &nbsp;</template>
                <template slot="FOOT_price"> &nbsp;</template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validatePop from "../plugins/validatePop.js"
import BacklogParcel from "@/components/custom/Backlog/Parcel/CardBacklog"
import ScanSOP from "@/components/custom/Backlog/Parcel/ScanSOP"
import moment from "moment";
const API_URL = process.env.VUE_APP_API;
export default {
  components:{
    BacklogParcel,
    ScanSOP
  },
  data() {
    return {
      TYPE:{
        SCAN: "SCAN",
        DEFAULT: "DEFAULT",
      },
      unLoad: false,
      deliveryId: null,
      createTypeBy: "DEFAULT",
      itemProduct: [],
      selectFilter: undefined,
      busy: true,
      userLogin: "",
      filter: '',
      filters: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      selected: [],
      checkSelect: false,
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  beforeRouteLeave (to, from, next) {
    if( this.unLoad ){
      const check = confirm("ท่านแน่ใจว่าต้องการออกจากหน้านี้")
      next(check)
      return true  
    }
    next()
  },
  created(){
    this.userLogin = JSON.parse(localStorage.getItem("user"))
    // window.addEventListener('beforeunload', this.boforeUnload)
  },
  mounted() {
    this.getDelivery();  
  },
  methods: {
    onScanSuccess(listOrderDetailIds){
      const indexOfItem = this.itemProduct.findIndex( item => {
        return item.id === listOrderDetailIds[0]
      })
      if( indexOfItem > -1 ){
        this.unLoad = true
        this.itemProduct.splice(indexOfItem, 1)
      }
    },
    onChangeCreateType(type = this.TYPE.DEFAULT){
      this.selected = []
      this.createTypeBy = type
    },
    boforeUnload(event) {
      if( this.unLoad ){
        event.returnValue = 'You have unsaved changes!'
      }
    },
    getDelivery() {
      this.busy = true;
      this.$http
        .post(
          API_URL + "/shop/delivery",
          {
            start: moment(this.filters.startDate).format("YYYY-MM-DD"),
            end: moment(this.filters.endDate).format("YYYY-MM-DD"),
            type: "ship"
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.checkSelect = false
          this.itemProduct = res.data.data
          this.itemProduct.forEach((data, i)=>{
            this.itemProduct[i].date_created = data.created_at.date
          });
          this.busy = false
        });
    },
    createDocumentDelivery(){
      this.busy = true
      this.$http
        .post(
          API_URL + "/shop/create/delivery",
          {
            delivery: this.selected,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.busy = false
              this.showErrorModal( checkError.msg )
              return false
            }
            this.busy = false
            this.printDelivery(res.data.data.deliveryHTML);
            this.showSuccessModal("สร้างใบนำส่งพัสดุเสร็จเรียบร้อยค่ะ ใบนำส่งพัสดุเลขที่ " + res.data.data.delivery_no);
            this.getDelivery();
        })
        .catch(error => {
          this.showErrorModal(error)
        });
    },
    printDelivery(html) {
      const win = window.open("");
      win.document.write(html);
      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
      }, 100);
    },
    isDetail() {
      return !!this.$route.params.Id;
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      if(this.itemFilter.length < 1){
        return false
      }
      this.checkSelect = !this.checkSelect
      if(this.checkSelect){
        this.$refs.reportDelivery.selectAllRows()
      }else{
        this.$refs.reportDelivery.clearSelected()
      }
    },
    showComfirmModal() {
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะสร้างใบนำส่งพัสดุ รายการที่เลือกจะไม่สามารถแก้ไขหรือนำมาสร้างใบนำส่งพัสดุใหม่ได้`, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.createDocumentDelivery();
          }
        });
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
  },
  computed: {
    fields(){ 
     let fields = [
        { key: "selected", label: "เลือกรายการ", class: "text-center" },
        { key: "index", label: "ลำดับ", sortable: true },
        { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
        { key: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
        { key: "province", label: "จังหวัดผู้รับ", sortable: true, class: "text-center"} ,
        { key: "postcode", label: "รหัสไปรษณีย์ผู้รับ", sortable: true, class: "text-center" },
        { key: "name", label: "ชื่อผู้รับ", sortable: true, class: "text-center" },
        { key: "barcode", label: "หมายเลข Tracking", sortable: true, class: "text-center" },
        { key: "courier", label: "ชื่อขนส่ง", sortable: true },
        { key: "weight", label: ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)', sortable: true },
        { key: "dimension", label: "ขนาดพัสดุ (ซม.)", sortable: true },
        { key: "price", label: "ราคาขาย", sortable: true },
      ]
      if( this.createTypeBy !== this.TYPE.DEFAULT ){
        fields = fields.filter( item => item.key !== 'selected')
      }
      return fields
    },
    itemFilter() {
      let item = this.itemProduct.filter(item => {
        let keys = Object.keys(item);
        if(this.selectFilter === undefined &&!this.filter){
          return true
        }
        else if (this.selectFilter === undefined && this.filter){
        return Object.values(item).some((val)=>{
          return String(val).toLowerCase().includes(this.filter.toLowerCase())
         })
        }
        else if(this.selectFilter !== undefined && !this.filter){
          return item.courier === this.selectFilter
        }
        else if (this.selectFilter !== undefined&&this.filter){
         return item.courier === this.selectFilter&&Object.values(item).some((val)=>{
          return String(val).toLowerCase().includes(this.filter.toLowerCase())
         })
        }
      })
      return item;
    },
    options() {
      // This could be simplified if the select was it's own component.
      let options = {};

      const vals = this.itemProduct.map(item => item.courier);

      options = Array.from(new Set(vals));

      return options;
    },
    total() {
      return this.itemFilter.reduce((total, product) => {
        return total + Number(product.price);
      }, 0);
    },
  }
};
</script>

<style></style>
 